(function () {
  function initBlogCta() {
    var content = document.querySelector('[data-toc-content]');
    if (!content) return;

    var blocks = {};
    var productSource = document.querySelector('.blog-cta-source');
    if (productSource) {
      productSource.querySelectorAll('[data-pcta]').forEach(function (block) {
        blocks['product-cta-' + block.getAttribute('data-pcta')] = block;
      });
    }
    var bannerSource = document.querySelector('.blog-cta-banner-source');
    if (bannerSource) {
      bannerSource.querySelectorAll('[data-bcta]').forEach(function (block) {
        blocks['banner-cta-' + block.getAttribute('data-bcta')] = block;
      });
    }

    Object.keys(blocks).forEach(function (code) {
      var shortcode = '[' + code + ']';
      var target = findShortcodeNode(content, shortcode);
      if (target) {
        var block = blocks[code];
        block.removeAttribute('hidden');
        target.node.parentNode.replaceChild(block, target.node);
        if (block.querySelector('[data-pcta-track]')) {
          initCarousel(block);
        }
      }
    });

    if (productSource) productSource.remove();
    if (bannerSource) bannerSource.remove();
  }

  function findShortcodeNode(root, shortcode) {
    var els = root.querySelectorAll('p, div');
    for (var i = 0; i < els.length; i++) {
      if (els[i].textContent.trim() === shortcode) {
        return { node: els[i] };
      }
    }
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var textNode;
    while ((textNode = walker.nextNode())) {
      if (textNode.nodeValue.trim() === shortcode) {
        return { node: textNode };
      }
    }
    return null;
  }

  function initCarousel(block) {
    var track = block.querySelector('[data-pcta-track]');
    var prev = block.querySelector('[data-pcta-prev]');
    var next = block.querySelector('[data-pcta-next]');
    if (!track) return;
    function slideStep() {
      var slide = track.querySelector('.blog-pcta__slide');
      if (!slide) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
      return slide.getBoundingClientRect().width + gap;
    }
    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -slideStep(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: slideStep(), behavior: 'smooth' });
    });

    var isDown = false, startX = 0, startScroll = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      isDown = true; moved = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      track.scrollLeft = startScroll - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
    });
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBlogCta);
  } else {
    initBlogCta();
  }
})();